export default "__VITE_ASSET__ba33e8d3__"